import React from 'react';
import { clientActivity } from '../../../mocks/client';

/**
 * Plain-English activity feed (T9.5): every line is written for a business
 * reader — no agent internals, no token speak. Newest first.
 */
function ClientActivityFeed({ limit }) {
  const items = limit ? clientActivity.slice(0, limit) : clientActivity;

  return (
    <ul className="portal-feed">
      {items.map((event) => (
        <li className={`portal-feed-item tone-${event.tone}`} key={event.id}>
          <div>
            <strong>{event.agent}</strong>
            <p>{event.text}</p>
          </div>
          <time>{event.time}</time>
        </li>
      ))}
      {!items.length && (
        <li className="portal-empty">No activity yet — your agents are warming up.</li>
      )}
    </ul>
  );
}

export default ClientActivityFeed;
